/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import {Form, FormGroup, FormControl, ControlLabel} from 'react-bootstrap';
import {Nav, NavItem, Glyphicon, Modal, Label, Button, Panel, ListGroup, ListGroupItem, Grid, Row, Col, Image, Checkbox} from 'react-bootstrap';
import UIHelpers from '../../library/UIHelpers';
import ProductChannelList from './productChannelList';
import ProductGroupedChannelList from './productGroupedChannelList';
import UserStore from '../../stores/UserStore';
import PinEditModal from './PinEditModal.react';

export default class ProductChannelViewSelector extends React.Component {
    constructor(props) {
        super(props);

        console.log("[ProductChannelViewSelector] - initialisation");    
        this.addPin = this.addPin.bind(this) ;
        this.editPin = this.editPin.bind(this) ;
        this.deletePin = this.deletePin.bind(this) ;
        this.editComplete = this.editComplete.bind(this);

        this.state = {
          editingPinState : null
        };
    }


    getPinIndex(pin) {
        let p = this.props.product;
        return p.pins.findIndex((element, index, array) => {
            return element.channel === pin.channel;
        });
    }

    deletePin(pin) {
        if (!UIHelpers.confirmAction("Are you sure you want to delete this PIN?")) {
          return ;
        }
  
        let p = this.props.product;
        var pinIndex = this.getPinIndex(pin);

        p.pins.splice(pinIndex, 1);
        this.props.onFinished(true) ; 
    }

    editPin(pin,group) {
        this.setState({editingPinState : {pin: pin, groupName: group}});
    }

    addPin(group) {        
        let newPin = {type: "digital", direction: "in"}
        this.setState({editingPinState : {pin: newPin, groupName: group}});
    }

    editComplete(updatedPin) {
        if (!updatedPin) {  // cancelled
            this.setState({editingPinState: null});
            return;
        }

        let p = this.props.product;
        var pinIndex = this.getPinIndex(updatedPin);

        if (pinIndex !== -1) {
            p.pins[pinIndex] = updatedPin;
        }
        else {
            p.pins.push(updatedPin);
        }

        this.setState({editingPinState: null});
        this.props.onFinished(updatedPin !== null) ;        
    }

    render() {
        var isAdmin = UserStore.isAdministrator();
        
        return (
            <div>              
                <ProductGroupedChannelList product={this.props.product} 
                    addPin={this.addPin}
                    editPin={this.editPin}
                    deletePin={this.deletePin}
                    /> 

                {isAdmin && this.state.editingPinState ? 
                    <PinEditModal
                        originalPin={this.state.editingPinState.pin}
                        pinGroupName={this.state.editingPinState.groupName}
                        onFinished={this.editComplete} />
                    : '' }
            </div>  
        ); 
    }
}



// WEBPACK FOOTER //
// ./src/app/components/products/productChannelViewSelector.js